/** Routes where floating call/chat widgets should not render (standalone / embedded pages). */
const WIDGET_FREE_PREFIXES = ['/digital-vos/view/']

export function isWidgetFreeRoute(pathname: string): boolean {
  return WIDGET_FREE_PREFIXES.some((prefix) => pathname.startsWith(prefix))
}
